const BREAST_RECONSTRUCTION = 'breastReconstruction';

export default BREAST_RECONSTRUCTION;
